<template>
    <div
        :class="{'child_status_icon': true, 'small': small }"
        :style="{ backgroundColor: color }"
        :title="title ? title : defaultTitle"
    >
        <i
            class="icon icon-inverse"
            :class="classes"
        ></i>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: false,
            example: 'Aktiv',
        },
        spinning: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        status: {
            type: String,
            required: false,
            example: 'active',
        },
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        classes() {
            let classes = [];
            classes.push('icon-' + this.icon);
            if (this.spinning) {
                classes.push('icon-pulse');
            }

            return classes;
        },
        icon() {
            if (this.spinning) {
                return 'spinner';
            }

            switch (this.status) {
                case 'signed_up':
                    return 'user-plus';

                case 'on_waiting_list':
                    return 'list';

                case 'waiting_for_contract_signing':
                    return 'pencil';

                case 'waiting_for_contract_start':
                    return 'clock';

                case 'active':
                    return 'check';

                case 'archived':
                    return 'close';

            }

            return 'circle-o';
        },
        defaultTitle() {
            if (this.spinning) {
                return '';
            }

            switch (this.status) {
                case 'signed_up':
                    return this.$t('child_contract_status.overview_application');

                case 'on_waiting_list':
                    return this.$t('child_contract_status.overview_onWaitinglist');

                case 'waiting_for_contract_signing':
                    return this.$t('child_contract_status.overview_waitingForSigning');

                case 'waiting_for_contract_start':
                    return this.$t('child_contract_status.overview_waitingForContactStart');

                case 'active':
                    return this.$t('child_contract_status.overview_activ');

                case 'archived':
                    return this.$t('child_contract_status.overview_inactiv');

            }

            return '';
        },
        color() {
            if (this.disabled) {
                return '#cbcbcb';
            }

            switch (this.status) {
                case 'signed_up':
                    return '#cbcbcb';

                case 'on_waiting_list':
                case 'waiting_for_contract_signing':
                case 'waiting_for_contract_start':
                    return '#FFC107';

                case 'active':
                    return '#4CAF50';

                case 'archived':
                    return '#F44336';
            }

            return '#cbcbcb';
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.child_status_icon {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    border-radius: 50%;
    &.small {
        width: 15px;
        height: 15px;
    }
}
</style>
